export const ACTIVITY_URL = 'https://hapi-activity.netlify.app';
